export const PaymentOptionType = {
	ONLINE: 'ONLINE',
	OFFLINE: 'OFFLINE',
	PACKAGE: 'PACKAGE',
	MEMBERSHIP: 'MEMBERSHIP',
}

export const CheckoutOptionType = {
	WIX_PAY_ONLINE: 'wixPay_Online',
	WIX_PAY_OFFLINE: 'wixPay_Offline',
	PACKAGE: 'package',
	MEMBERSHIP: 'membership',
}
